import React from "react";
import {ColumnChartStyles} from "./ColumnChart.styles";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import logoSignature from '../../../IB_Signature.png';
import HighchartsMore from "highcharts/highcharts-more";
import { updateChartTheme } from "src/utils/helpsers";

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
HighchartsMore(Highcharts);

/**
 * Column chart using highcharts library.
 * @param {string} title - The title of the chart.
 * @param {array} data - An array data to be rendered in the chart.
 */

const ColumnChart = ({data, title}) => {

  let logoCredit;
  const pieChartData = {
    chart: {
      backgroundColor: '#fff',
      zoomType: 'xy',
      style: {
        fontFamily: ['Titillium Web', 'sans-serif']
      },
      events: {
        load: function () {
          if (this.options.chart.forExport) {
            this.renderer.image(`${logoSignature}`, 10, 15, 100, 15).add();
          }
        },
        beforePrint: function () {
          logoCredit = this.renderer.image(`${logoSignature}`, 10, 15, 100, 15).add();
          this.print();
        },
        afterPrint: function () {
          logoCredit.element.remove();
        }
      },
    },
    title: {
      text: title,
    },
    xAxis: [{
      categories: data[0].categories,
      crosshair: true
    }],
    yAxis: [{ // Primary yAxis
      labels: {
        format: '{value}',
      },
      title: {
        text: 'Enrolled ADM',
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }, { // Secondary yAxis
      title: {
        text: 'Districts'
      },
      labels: {
        format: '{value}'
      },
      opposite: true
    }],
    tooltip: {
      shared: true,
      backgroundColor: '#FFF',
      pointFormatter: function () {
        let color = this.selected ? this.series.options.states.select.color : this.color;

        return `<span style="color:${color}">\u25CF</span> ${this.series.name}: <b>${this.y}</b><br>`;
      } 
    },
    exporting: {
      tableCaption: false,
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            {
              text: "Toggle Light/Dark mode",
              onclick: function () {
                updateChartTheme(this);
              }
            },
            {
              separator: true,
            },
            {
              text: "Download PDF document",
              onclick: function () {
                window._paq.push([
                  "trackEvent",
                  "Board DistrictInsights",
                  `Downloaded: PDF in ${title}`,
                ]);
                this.exportChart({
                  type: "application/pdf",
                });
              },
            },
            {
              text: "Download CSV",
              onclick: function () {
                window._paq.push([
                  "trackEvent",
                  "Board DistrictInsights",
                  `Downloaded: CSV in ${title}`,
                ]);
                this.downloadCSV();
              },
            },
            {
              text: "Download XLS",
              onclick: function () {
                window._paq.push([
                  "trackEvent",
                  "Board DistrictInsights",
                  `Downloaded: XLS in ${title}`,
                ]);
                this.downloadXLS();
              },
            },
            {
              separator: true,
            },
            {
              text: 'Toggle Raw Data Table',
              onclick: function() {
                if (this.dataTableDiv && this.dataTableDiv.style.display !== 'none') {
                  this.dataTableDiv.style.display = 'none';
                } else {
                  this.viewData();
                  this.dataTableDiv.style.display = '';
                }
              }
            }
          ],
        },
      },
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      floating: false,
      verticalAlign: 'top',
    },

    series: [{
      name: 'Districts',
      states: {
        select: {
          borderColor: '#ff5569',
          color: '#ff5569',
        }
      },
      type: 'column',
      yAxis: 1,
      color: '#773dbd',
      data: data[0].data,
    }, {
      name: 'Enrolled ADM',
      states: {
        select: {
          borderColor: '#f5b335',
          color: '#f5b335',
        }
      },
      color: '#E1D7F0',
      type: 'column',
      data: data[0].data_sum
    }]
  }

  return (
    <Box sx={ColumnChartStyles}> 
      <HighchartsReact
        highcharts={Highcharts}
        options={pieChartData}
      />
    </Box>
  )
}

ColumnChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
}

export default ColumnChart;
